import { render, staticRenderFns } from "./contactDetail.vue?vue&type=template&id=5df8122e&scoped=true&"
import script from "./contactDetail.vue?vue&type=script&lang=js&"
export * from "./contactDetail.vue?vue&type=script&lang=js&"
import style0 from "./contactDetail.vue?vue&type=style&index=0&id=5df8122e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8122e",
  null
  
)

export default component.exports